export default "__VITE_PUBLIC_ASSET__ee855b60__"